<template>
  <div class="content">
    <div class="container-fluid">
      <!-- https://getbootstrap.com/docs/4.0/components/navbar/ -->
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <span class="navbar-brand h1">Liste des entités</span>
        <li class="nav-item nav-link">
          <form class="form-inline my-1 my-lg-2">
            <input v-model="filter" class="form-control mr-sm-2" type="search" placeholder="Chercher" aria-label="Chercher">
          </form>
        </li>
        <li class="nav-item nav-link">
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-2"
            ></b-pagination>
        </li>
        <li class="na-item nav-link">
          <span>{{ totalRows }} / {{ totalInitial }}</span>
        </li>

      </nav>



      <!-- <h1>Liste des sociétés</h1>

        <b-row>
          <b-col lg="6" class="my-1">
            <b-form-group
              label="Chercher"
              label-for="filter-input"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  placeholder="Texte de recherche"
                ></b-form-input>

                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">X</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="6" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row> -->
        
        <div>
        <b-table striped hover 
          responsive
          v-if="items.length>0"
          :items="items" 
          :fields="columns" 
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          > 
          <!--
          
          :data-cookie="true"
          :data-cookie-id-table="'saveId'"

          data-cookie="true"
          data-cookie-id-table="saveId"

          data-state-save="true"
          data-state-save-id="companiesId"-->
          <!-- show-empty -->
          <!-- stacked="md" -->
          <!-- small -->


          
          <!-- ENTITE -->
          <template #cell(name)="row">
            <!-- <router-link :to="urlWithRedirect('/ppe_eu/home/'+row.item.owner.id+'?companyid='+row.item.id)">{{row.item.name}}</router-link> -->
            <router-link :to="urlWithRedirect('/admin/company/'+row.item.id)">{{row.item.name}}</router-link>
          </template>

          <!-- B1 -->
          <template #cell(_modified)="row">
            <router-link :to="urlWithRedirect('/ppe_eu/company_eu/'+row.item.id)">
              <status-icon :status="row.item._status" /> 
              {{toDate(row.item._modified)}}
            </router-link>
          </template>
          <!-- B2 -->
          <!-- <template #cell(B2._status)="row">
              <router-link :to="urlWithRedirect('/ppe_eu/b2/'+row.item.B2.id+'?companyid='+row.item.id)">
                <status-icon :status="row.item.B2._status" />
                {{ toDate(row.item.B2._modified) }}
              </router-link>
          </template> -->
          <!-- B3 -->
          <!-- <template #cell(B3._status)="row">
            <router-link :to="urlWithRedirect('/ppe_eu/b3/'+row.item.B2.id+'?companyid='+row.item.id)">
              <status-icon :status="row.item.B3._status" />
              {{ toDate(row.item.B3._modified) }}
            </router-link>
          </template> -->

          <template #cell(owner.name)="row">
            <!-- <router-link :to="urlWithRedirect('/ppe_eu/account/'+row.item.owner.id)"> -->
            <router-link :to="urlWithRedirect('/ppe_eu/home/'+row.item.owner.id)">  
              {{ row.item.owner.name }}
            </router-link>
          </template>

          <template #cell(parent)="row">
            <router-link v-if="row.item.parent && row.item.parent.id !== row.item.id" :to="urlWithRedirect('/admin/company/'+row.item.parent.id)">  
              {{ row.item.parent.name }}
            </router-link>
          </template>
        </b-table>
        </div>

    </div>
  </div>
</template>

<style>
.table > tbody > tr > td:last-child {
  width: auto;
}
</style>

<script>
import StatusIcon from '../../components/StatusIcon.vue'

const Business = require('ppe-business')

import common from '../common/pages.js'

export default {
  components: {
    StatusIcon,
  },

  data() {
    return { 
      items : [ ],
      columns: [
          {key:'name',          label:'Entité',     sortable: true,}, 
          {key:'_modified',     label:'Modifié', sortable: true},
          //{key:'B2._status',    label:'B2',      sortable: true,}, 
          //{key:'B3._status',    label:'B3',      sortable: true,}, 
          {key:'city',          label:'Ville',   sortable: true,},
          {key:'countOperations',label:'Opérations',  sortable: true,}, 
          {key:'parent',        label:'Entité parente',  sortable: true,}, 
          {key:'owner.name',    label:'Compte principal',  sortable: true,}, 
          //{key:'AKCsync',       label:'Sync AKC', sortable: true},
          //{key:'id',            label:'Action'},

          ],
      filter: null,
      currentPage:1,
      totalRows:0,
      totalInitial:0,
      perPage:100,

    }
  },

  mounted() {
    this.$http.get('/admin/companies')
        .then(response => {
          console.log("/admin/companies", response.data)
          // Map the result to add the _rowVariant attribute to color the full line
          this.items = response.data.companies.map( function (a)  { 
            // https://bootstrap-vue.org/docs/components/table#items-record-data
            return {...a, _rowVariant:Business.getStatusClass(a._status)} } )
          this.totalRows = this.items.length
          this.totalInitial = this.totalRows
          } )
        .catch( (err, res) => {
          // Clone the error to read the status property (otherwise it can only be read once !!!!)
          let error = JSON.parse( JSON.stringify(err) )
					
					swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
        })
    },

  methods: {
    ...common.methods,

    toDate(apiDate) { return Business.toDate(apiDate) },
  }
}
</script>